<form [formGroup]="searchForm">
  <div class="header-search-component row">
    <div class="search-category-container" style="max-width:220px;">
      <kendo-combobox class=""
                      #categorySearch
                      formControlName="selectedCategory"
                      [data]="pbData"
                      [textField]="'name'"
                      [valueField]="'value'"
                      placeholder="{{headerSearchTxt.categoryPickLbl?headerSearchTxt.categoryPickLbl:search.categoryPickLbl }}"
                      [virtual]="true"
                      [filterable]="true"
                      [suggest]="true"
                      [valuePrimitive]="true"
                      style="max-width:220px;"
                      (selectionChange)="handlePriceBookCategorySelection($event)"
                      (filterChange)="handlePriceBookCategoryFilter($event)">
        <ng-template kendoDropDownListHeaderTemplate>
          {{headerSearchTxt.availPriceBookCategoriesLbl?headerSearchTxt.availPriceBookCategoriesLbl:search.availPriceBookCategoriesLbl}}:
        </ng-template>
      </kendo-combobox>
    </div>

    <div class="search-item-and-icon-container" style="max-width:250px;">
      <div class="row search-item-container">
        <kendo-autocomplete class="col searchCls"
                            #itemSearch
                            name="selectedItem"
                            formControlName="selectedItem"
                            [(ngModel)]="selectedItem"
                            [data]="filteredItems "
                            [valueField]="'fullDescription'"
                            placeholder="{{ headerSearchTxt.searchCatalogLbl?headerSearchTxt.searchCatalogLbl:search.searchCatalogLbl }}"
                            [virtual]="true"
                            [filterable]="true"
                            [highlightFirst]="false"
                            (filterChange)="handleItemFilter($event)"
                            (valueChange)="itemSelected($event)"
                            [loading]="searchingItem">
          <ng-template kendoAutoCompleteItemTemplate let-dataItem
                       *ngIf="true">
            <ng-container *ngFor="let substring of splitText(dataItem.fullDescription)">
              <ng-container *ngIf="
                    substring.toLowerCase() ===
                      currentInputValueInItemSearch.toLowerCase();
                    else boldTemplateName
                  ">
                <span>{{ substring }}</span>
              </ng-container>
              <ng-template #boldTemplateName>
                <b>{{ substring }}</b>
              </ng-template>
            </ng-container>
          </ng-template>

          <ng-template kendoAutoCompleteNoDataTemplate>
            <div *ngIf="showSuggestionBox">
              <h4>
                <span class="k-icon k-i-warning"></span>
                <br /><br />
                {{headerSearchTxt.noItemMatchLbl?headerSearchTxt.noItemMatchLbl:search.noItemMatchLbl}}
                <br />
                "{{ currentInputValueInItemSearch }}"
              </h4>
            </div>
          </ng-template>
        </kendo-autocomplete>
        <div class="search-icon-container" (click)="gotoSearchResult('/advanced-search')">
          <span class="k-icon k-i-search"></span>
        </div>
      </div>
    </div>
    <div class="search-advanced-container" style="max-width:201px;">

      <button kendoButton class="fade-on-hover" (click)="gotoAdvancedSearch('/advanced-search')"
              [routerLink]="['/advanced-search']">
        {{headerSearchTxt.advancedSearchLbl?headerSearchTxt.advancedSearchLbl:search.advancedSearchLbl}}
      </button>
    </div>
    &nbsp;
    <div class="search-advanced-container overstock-advanced-container">
      <button kendoButton class="fade-on-hover" *ngIf="showclearance" (click)="gotoDiscountStore('/overstock')"
              style="background-color: red !important; font-weight:bold;"
              [routerLink]="['/overstock']">
        Overstock
      </button>
    </div>
  </div>
</form>
